import { createElement } from 'src/app/core/helpers/dom';
import Tooltip from 'src/app/project/features/tooltip/Tooltip';
import { iconMap } from 'src/app/project/shared/enums/icon-map';
import { EIconPath } from '../../../../../shared/enums/icons.enum';
import { TColumn } from '../../columns/column.model';
import { GET_TABLE } from '../../table.ui.store';
import { createMarkedKeywordElement } from '../body-cells-search';
import { createCellElement } from '../createCellElement';

function createIconElement(icon: string, title: string): HTMLElement {
  const imageElementWrapper = createElement('div', {
    attrs: {
      class: 'customSiteTable--attachments',
      'aria-label': title,
    },
  });
  imageElementWrapper.innerHTML = icon;

  const imageTooltip = new Tooltip({
    title,
    mobileTooltip: false,
    childTooltip: false,
    element: imageElementWrapper,
    trimTooltip: false,
    trimElement: imageElementWrapper,
    options: {
      placement: 'right',
    },
  });

  imageTooltip.createTooltip();

  return imageElementWrapper;
}

export function createTitleElement(index: number, column: TColumn): HTMLElement {
  const table = GET_TABLE();
  const point = table.getPoints()[index];

  const iconElements: HTMLElement[] = [];

  if (point.containsAttachments) {
    iconElements.push(
      createIconElement(iconMap[EIconPath.ICON_TABLE_ATTACHMENTS], 'Contains attachments'),
    );
  }

  if (point.hasRelationships) {
    iconElements.push(
      createIconElement(iconMap[EIconPath.ICON_RELATED_LINK], 'Related to another point'),
    );
  }

  const hasIcons = iconElements.length > 0;
  const textClass = hasIcons
    ? 'customSiteTable__text customSiteTable__text--title'
    : 'customSiteTable__text';

  return createCellElement({
    index: column.index,
    width: `${column.width}px`,
    child: createElement('div', {
      attrs: {
        class: textClass,
      },
      children: [createMarkedKeywordElement(point.title), ...iconElements],
    }),
  });
}
